import React from 'react';
import { useSelector } from 'react-redux';
import Behaviour from 'components/prism/behaviour';

export const Recommended = ({ text, data }) => {
    const { prismMultiColumn } = useSelector(state => state.ui);

    return (
        <>
            <h2 className="mb10">{text.recommended} 
                <span className="ml10" style={{ fontWeight: 400 }}>
                    {data?.length}
                </span>
            </h2>
            <div className="mb10">{text.recommendedSummary}</div>
            <div className={prismMultiColumn ? 'even-col' : ''}>
                {data.map(item => (
                    <Behaviour key={`recommended-${item.id}`} padBottom={!prismMultiColumn} item={item} />
                ))}
            </div>
        </>
    );
};

export default Recommended;
